import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Stack,
  Box,
  ListItemAvatar,
  ListItem,
  ListItemText,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import dayjs from "dayjs";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";
import LimitedTextBox from "components/ui/atoms/LimitedTextBox";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import OverflowTip from "components/ui/atoms/OverflowTip";

const CompanyListItem = ({ company, onClick }) => {
  return (
    <ListItem
      onClick={() => onClick(company.id, company)}
      sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
    >
      <ListItemAvatar>
        <Avatar src={`http://logo.clearbit.com/${company.best_domain}`}>
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <Stack
        direction={{ xs: "row", md: "column" }}
        alignItems={{ xs: "center", md: "start" }}
        spacing={0}
        sx={{
          width: { xs: "calc(100% - 56px)", md: "20%" },
          maxWidth: { xs: "auto", md: "250px" },
          flexGrow: 0,
          flexShrink: 0,
        }}
      >
        <ListItemText
          primary={<OverflowTip>{company.best_name}</OverflowTip>}
          secondary={company.best_domain}
        />

        <TypographyWithMiss
          variant="caption"
          isMissing={!company.hasOwnProperty("deal_owner.first_name")}
        >
          {company["deal_owner.first_name"]} {company["deal_owner.last_name"]}
        </TypographyWithMiss>
      </Stack>
      <Box
        sx={{
          width: { xs: "100%", md: "100%" },
          ml: { xs: 0, md: 2 },
          alignSelf: "stretch",
        }}
      >
        <LimitedTextBox
          title="Description"
          content={company.description}
          limit={5}
        />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "20%" },
          maxWidth: { md: 120 },
          ml: { xs: 0, md: 2 },
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <LabelValueForText
          label="Created at:"
          value={dayjs(company.created_at).format("DD/MM/YYYY")}
          variant="ForListItem"
        />
      </Box>
    </ListItem>
  );
};

export default CompanyListItem;
